import { SeasonInfo, seasonInfoSchema } from '@apeiron/download'
import { deserializeData, MayNull } from '@apeiron/temp'
import { useQuery } from '@apollo/client'
import graphql from '@src/graphql/query/getCurrentSeason'
import * as R from 'ramda'
import { useMemo } from 'react'

const useGetCurrentSeason = (): Hook => {
  const { data: response, loading } = useQuery(graphql)

  const result = useMemo((): Response => {
    return R.isNotNil(response)
      ? deserializeData<SeasonInfo>(response, seasonInfoSchema)
      : null
  }, [response])

  return {
    data: result,
    loading
  }
}

type Response = MayNull<SeasonInfo>

type Hook = {
  data: Response
  loading: boolean
}

export default useGetCurrentSeason
